import { Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';

import { AuthService } from '../services/utils/auth.service';

/**
 * Rend un bloc si le jeton porte l'une des permissions demandées.
 *
 * <pre>
 *   &lt;button *appCan="'library.write.own'"&gt;Déposer&lt;/button&gt;
 *   &lt;section *appCan="['sessions.inspect', 'sessions.read.all']"&gt;…&lt;/section&gt;
 * </pre>
 *
 * <p>Même règle que le menu : on ne propose pas un geste qui répondrait 403.
 * Ce n'est pas une barrière — le serveur redemande la permission — c'est ce
 * qui évite d'afficher un bouton mort. Une section conditionnée par une
 * permission se lit ainsi dans le gabarit, sans `if` dans le composant.</p>
 */
@Directive({ selector: '[appCan]', standalone: true })
export class CanDirective {
  private readonly auth = inject(AuthService);
  private readonly template = inject(TemplateRef<unknown>);
  private readonly container = inject(ViewContainerRef);

  private rendered = false;

  @Input({ required: true })
  set appCan(permissions: string | string[]) {
    const wanted = Array.isArray(permissions) ? permissions : [permissions];
    const allowed = wanted.some((p) => this.auth.hasPermission(p));

    if (allowed && !this.rendered) {
      this.container.createEmbeddedView(this.template);
      this.rendered = true;
    } else if (!allowed && this.rendered) {
      this.container.clear();
      this.rendered = false;
    }
  }
}
